import { RouteName } from "constant/routeNames";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { clearDataWhenLogout } from "redux/AudioPlayerRedux";
import { logout } from "redux/userRedux";
import AuthService from "services/auth/AuthService";
import LoadingSpin from "components/Loading spins/LoadingSpin";
import { useState } from "react";
import {
  FiUser,
  FiSettings,
  FiCreditCard,
  FiTv,
  FiVideo,
  FiMessageSquare,
  FiLogOut,
} from "react-icons/fi";
import { FaCrown } from "react-icons/fa";

function ProfileIconSubMenu({ className }: any) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const enabled = localStorage.getItem("ppv_enabled");
  const subscriptionEnabled = localStorage.getItem("subscription_enabled");

  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const isPlusUser = loggedInUser?.is_subscribed;

  const handleLogout = (e: any) => {
    e.preventDefault();
    setLoading(true);
    AuthService.logout()
      .then((response: any) => {
        if (response.status === 200) {
          dispatch(logout());
          navigate("/login");
          dispatch(clearDataWhenLogout());
        }
        setLoading(false);
      })
      .catch((e: Error) => {
        setLoading(false);
      });
  };

  const itemClass =
    "sub-menu-item flex items-center gap-3 rounded-lg px-3 py-2 text-[14px] text-white/80 transition-colors hover:bg-white/5 hover:text-white";

  return (
    <div
      className={`submenu-main navbar absolute w-64 rounded-2xl border border-white/10 bg-[#15151a]/95 p-2 text-left text-white shadow-[0_20px_60px_rgba(0,0,0,0.5)] backdrop-blur-xl max-sm:min-h-[150px] ${
        className && className
      }`}
    >
      {/* user header */}
      <Link
        to={RouteName.UserProfile.replace("*", loggedInUser.username)}
        className="mb-1 flex items-center gap-3 rounded-xl p-2 transition-colors hover:bg-white/5"
      >
        <div className="relative shrink-0">
          <img
            src={loggedInUser?.artwork_url}
            alt="profile"
            className="h-11 w-11 rounded-full object-cover ring-1 ring-white/15"
          />
          {isPlusUser && (
            <span className="absolute -bottom-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-[var(--red)] ring-2 ring-[#15151a]">
              <FaCrown className="text-[9px] text-white" />
            </span>
          )}
        </div>
        <div className="min-w-0">
          <p className="truncate text-[14px] font-semibold text-white">
            {loggedInUser?.name}
          </p>
          <p className="truncate text-[12px] text-white/50">
            @{loggedInUser?.username}
          </p>
        </div>
      </Link>

      <div className="my-1 border-t border-white/10" />

      {/* menu items */}
      <div>
        <Link to={RouteName.UserProfile.replace("*", loggedInUser.username)}>
          <p className={itemClass}>
            <FiUser className="text-[16px] text-white/60" />
            My Profile
          </p>
        </Link>

        <Link to={RouteName.EditProfile}>
          <p className={itemClass}>
            <FiSettings className="text-[16px] text-white/60" />
            Settings
          </p>
        </Link>

        {loggedInUser && subscriptionEnabled === "1" && (
          <Link to={RouteName.MemberPage}>
            <p className={itemClass}>
              <FiCreditCard className="text-[16px] text-white/60" />
              Membership
            </p>
          </Link>
        )}

        {enabled === "1" && (
          <Link to={RouteName.PPVSubscription}>
            <p className={itemClass}>
              <FiTv className="text-[16px] text-white/60" />
              PPV Events
            </p>
          </Link>
        )}

        {subscriptionEnabled === "1" && (
          <Link to={RouteName.SubscriptionPlanRoute}>
            <p className="sub-menu-item flex items-center gap-3 rounded-lg px-3 py-2 text-[14px] font-semibold text-[var(--red)] transition-colors hover:bg-[var(--red)]/10">
              <FaCrown className="text-[15px]" />
              Plans
            </p>
          </Link>
        )}

        <Link to={RouteName.BecomeACreator}>
          <p className={itemClass}>
            <FiVideo className="text-[16px] text-white/60" />
            Become a Creator
          </p>
        </Link>

        <Link to={RouteName.UserChat.replace("*", "")}>
          <p className={itemClass}>
            <FiMessageSquare className="text-[16px] text-white/60" />
            Chat
          </p>
        </Link>

        <div className="my-1 border-t border-white/10" />

        <p
          className="sub-menu-item flex cursor-pointer items-center justify-between rounded-lg px-3 py-2 text-[14px] text-red-500 transition-colors hover:bg-red-500/10"
          onClick={handleLogout}
        >
          <span className="flex items-center gap-3">
            <FiLogOut className="text-[16px]" />
            Sign out
          </span>
          <span>
            {loading ? <LoadingSpin fontSize={20} color={"red"} /> : ``}
          </span>
        </p>
      </div>
    </div>
  );
}

export default ProfileIconSubMenu;